import React from "react";
import { Query } from "react-apollo";
import { Spin } from "antd";

import GetOrderPartner from "../../GraphQL/Query/GetOrderPartner";
import OrderFile from "./OrderFile";

class OrderResponseFiles extends React.Component {
  render() {
    const { order, orderId } = this.props;
    return (
      <Query
        query={GetOrderPartner}
        variables={{ orderId, userId: order.partnerAssignedId }}
        fetchPolicy="cache-and-network"
      >
        {({ loading, error, data }) => {
          if (loading) return <Spin />;
          if (error) return <p>Error :(</p>;
          const { getOrderPartner: orderPartner = {} } = data;

          // console.log(orderPartner);
          return (
            <div>
              {orderPartner.files.map(file => (
                <OrderFile key={file.key} file={file} />
              ))}
              <div style={{ marginTop: 12 }}>
                <b>Comentarios de la respuesta.</b> {orderPartner.comments}
              </div>
            </div>
          );
        }}
      </Query>
    );
  }
}

export default OrderResponseFiles;



// WEBPACK FOOTER //
// ./src/Components/Orders/OrderResponseFiles.js